import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { userAtom } from '../../jotai-atoms/user.atom';
import { CountdownTimer } from './CountdownTimer';
import { WidgetLiveClass } from './WidgetLiveClass.type';
import { WidgetSize } from './WidgetSize.type';

export interface CountdownWidgetStateCountdownProps {
  liveClass: WidgetLiveClass;
  isThin?: boolean;
  size?: WidgetSize;
}

export const CountdownWidgetStateCountdown = ({
  liveClass,
  isThin,
  size,
}: CountdownWidgetStateCountdownProps) => {
  const __ = useTranslation().t;

  const title = size === 'sm' ? __('nextLiveClass') : __('gettingReady');
  const subtitle = __('classStartsIn');

  const [user] = useAtom(userAtom);

  if (size === 'sm') {
    return (
      <BannerContainer>
        <BannerTextContainer>
          <Title sm>{title}</Title>
          <Subtitle sm>{subtitle}</Subtitle>
        </BannerTextContainer>
        <CountdownTimer targetDate={liveClass.dateTime || ''} timezone={user?.timezone} sm />
      </BannerContainer>
    );
  }

  return (
    <Container>
      <Title>{title}</Title>
      {!isThin && <StyledHr />}
      <Subtitle>{subtitle}</Subtitle>
      <CountdownTimer targetDate={liveClass.dateTime || ''} timezone={user?.timezone} />
    </Container>
  );
};

interface TitleProps {
  sm?: boolean;
}

const Title = styled.h6<TitleProps>`
  font-family: 'Inter';
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.dark};

  ${({ sm, theme }) =>
    sm
      ? `
      @media screen and (max-width: ${theme.screenSizes.xs}) {
        font-size: 10px;
        line-height: 12px;
      }
  `
      : ``}
`;

const StyledHr = styled.hr`
  margin: 12px 0;
  border: 1px solid ${({ theme }) => theme.colors.backgroundDark};
`;

interface SubtitleProps {
  sm?: boolean;
}

const Subtitle = styled.p<SubtitleProps>`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #444444;
  ${({ sm }) =>
    sm
      ? ``
      : `
    margin-top: 4px;
    margin-bottom: 12px !important;
  `}

  ${({ sm, theme }) =>
    sm
      ? `
      @media screen and (max-width: ${theme.screenSizes.xs}) {
        font-size: 14px;
        line-height: 20px;
      }
  `
      : ``}
`;

const Container = styled.div`
  text-align: center;
`;

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 410px;
  margin: auto;
`;

const BannerTextContainer = styled.div`
  flex: 1;
`;
